import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import technitionService from "../services/technition.service";
import { Technitionvalidationschema } from "../components/Validation";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import imagename from "../assets/images/user.png";

const Technitionevent = (props) => {
  const [showPass, setShowPass] = useState(false);
  const ref = useRef();
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const [techn_id, setTechnitionid] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventname, setEventname] = useState("view");

  //form initial value
  const formik = useFormik({
    initialValues: {
      techn_id: "",
      techn_fullname: "",
      techn_username: "",
      techn_password: "",
      techn_email: "",
      techn_phone: "",
      techn_role: "",
      techn_address: "",
      techn_status: "",
    },
    validationSchema: Technitionvalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      //alert(JSON.stringify(values, null, 1));
      /*  resetForm({ values: '' }) */
    },
  });
  //use effects
  useEffect(() => {
    setTechnitionid(searchParams.get("techn_id"));
    if (searchParams.get("techn_id")) {
      setEventname("view");
      getTechnition(searchParams.get("techn_id"));
    } else {
      setEventname("create");
    }
  }, []);

  //current event
  const technitionEvent = (eventname, value) => {
    if (value) {
      getTechnition(value);
    }
    setEventname(eventname);
  };

  //get technition
  const getTechnition = (value) => {
    setIsLoaded(true);
    technitionService
      .getTechnition(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            techn_id: data.techn_id,
            techn_fullname: data.techn_fullname,
            techn_username: data.techn_username,
            techn_password: data.techn_password,
            techn_email: data.techn_email,
            techn_phone: data.techn_phone == null ? "" : data.techn_phone,
            techn_address: data.techn_address == null ? "" : data.techn_address,
            techn_role: data.techn_role == null ? "" : data.techn_role,
            techn_status: data.techn_status == null ? "" : data.techn_status,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  //create technition
  const createTechnition = () => {
    technitionService
      .createTechnition(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          console.log(res.data);
          setIsLoaded(false);
          navigate("/technition");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };

  //update technition
  const updateTechnition = () => {
    console.log(JSON.stringify(formik.values, null, 2));
    technitionService
      .updateTechnition(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          technitionEvent("view");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //delete technition
  const deleteTechnition = (value) => {
    console.log(value);
    technitionService
      .deleteTechnition(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          navigate("/technition");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  // Call technition clicks to request another page.
  if (isLoaded) {
    <Loader />;
  } else {
    return (
      <div className="container">
        {/*  container */}
        <div className="technition-container">
          {/* form container */}
          <div className="card shadow-sm border-0 ">
            <div className="card-body ">
              <div className="d-flex p-2 ">
                <h5 className="card-title p-0 m-0 me-auto"></h5>
                {eventname == "create" ? (
                  <></>
                ) : (
                  <div>
                    <div className="dropdown">
                      <a
                        className="btn  btn-link"
                        href="#"
                        role="button"
                        id="technitioneventdropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="technitioneventdropdownMenuLink"
                      >
                        <li>
                          <a
                            onClick={() => {
                              technitionEvent("edit");
                            }}
                            className="dropdown-item"
                          >
                            Edit
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => technitionEvent("delete")}
                            className="dropdown-item"
                          >
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/*  profile section */}
                  <div className="col-md-3 ">
                    <div
                      className="d-flex justify-content-center "
                      style={{ position: "relative" }}
                    >
                      <div>
                        <img
                          style={{
                            width: 150,
                            height: 150,
                            borderRadius: "50%",
                          }}
                          src={imagename ? imagename : imagename}
                        />
                      </div>
                      {/* <div
                        style={{ position: "absolute", bottom: 0, right: 90 }}
                      >
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#uploadmodal"
                          className="btn btn-sm btn-secondary "
                        >
                          <i className="fa fa-pencil-square-o"></i>
                        </button>
                      </div> */}
                    </div>
                    <div>
                      <div className="col-md-12">
                        <label htmlFor="techn_username" className="form-label">
                          Technitionname
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter username"
                            id="techn_username"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("techn_username")}
                          />
                        </div>
                        <div>
                          {formik.touched.techn_username &&
                          formik.errors.techn_username ? (
                            <div className="error">
                              {formik.errors.techn_username}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label
                          className="form-label me-4"
                          htmlFor="techn_password"
                        >
                          Password
                        </label>
                        <div className="input-group ">
                          <input
                            className="form-control"
                            id="techn_password"
                            type={showPass ? "text" : "password"}
                            autoComplete="off"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("techn_password")}
                          />
                          <span
                            onClick={() => setShowPass(!showPass)}
                            className="input-group-text bg-white"
                          >
                            <i
                              className={
                                showPass ? "fa fa-eye-slash" : "fa fa-eye"
                              }
                            ></i>{" "}
                          </span>
                        </div>
                        {formik.touched.techn_password &&
                        formik.errors.techn_password ? (
                          <div className="error">
                            {formik.errors.techn_password}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-12">
                        <label htmlFor="techn_email" className="form-label">
                          Email
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter Email"
                            id="techn_email"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("techn_email")}
                          />
                        </div>
                        <div>
                          {formik.touched.techn_email &&
                          formik.errors.techn_email ? (
                            <div className="error">
                              {formik.errors.techn_email}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* form section */}
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-md-12 ">
                        <label htmlFor="techn_fullname" className="form-label">
                          Fullname
                        </label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            placeholder="Enter Fullname"
                            id="techn_fullname"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("techn_fullname")}
                          />
                        </div>
                        <div>
                          {formik.touched.techn_fullname &&
                          formik.errors.techn_fullname ? (
                            <div className="error">
                              {formik.errors.techn_fullname}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label htmlFor="techn_phone" className="form-label">
                          Phone
                        </label>
                        <div className="input-group col-md-6">
                          <input
                            className="form-control"
                            placeholder="Enter Phone"
                            id="techn_phone"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("techn_phone")}
                          />
                        </div>
                        <div>
                          {formik.touched.techn_phone &&
                          formik.errors.techn_phone ? (
                            <div className="error">
                              {formik.errors.techn_phone}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-12 ">
                        <label htmlFor="techn_address" className="form-label">
                          Address
                        </label>
                        <div className="input-group">
                          <textarea
                            className="form-control"
                            placeholder="Enter Address"
                            id="techn_address"
                            type="text"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            {...formik.getFieldProps("techn_address")}
                          ></textarea>
                        </div>
                        <div>
                          {formik.touched.techn_address &&
                          formik.errors.techn_address ? (
                            <div className="error">
                              {formik.errors.techn_address}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="techn_role" className="form-label">
                          Role
                        </label>
                        <div className="input-group col-md-6">
                          <select
                            id="techn_role"
                            {...formik.getFieldProps("techn_role")}
                            className="form-select"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            aria-label="techn_role"
                          >
                            <option value="" disabled>
                              Select Role
                            </option>
                            <option value="admin">Admin</option>
                            <option value="member">Editor</option>
                            <option value="member">Member</option>
                          </select>
                        </div>
                        <div>
                          {formik.touched.techn_role &&
                          formik.errors.techn_role ? (
                            <div className="error">
                              {formik.errors.techn_role}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="techn_status" className="form-label">
                          status
                        </label>
                        <div className="input-group col-md-6">
                          <select
                            id="techn_status"
                            {...formik.getFieldProps("techn_status")}
                            className="form-select"
                            disabled={
                              eventname == "view"
                                ? true
                                : eventname == "delete"
                                ? true
                                : false
                            }
                            aria-label="techn_status"
                          >
                            <option value="" disabled>
                              Select status
                            </option>
                            <option value="pending">Pending</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </div>
                        <div>
                          {formik.touched.techn_status &&
                          formik.errors.techn_status ? (
                            <div className="error">
                              {formik.errors.techn_status}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-12 pt-2 pb-2">
                        {eventname === "create" ? (
                          <>
                            <button
                               disabled={!formik.isValid || !formik.dirty}
                              onClick={() => createTechnition()}
                              className="btn btn-primary me-2"
                            >
                              Create
                            </button>
                            <button
                              onClick={formik.handleReset}
                              className="btn btn-secondary"
                            >
                              Clear
                            </button>
                          </>
                        ) : eventname === "edit" ? (
                          <>
                            {" "}
                            <button
                             disabled={!formik.isValid || !formik.dirty}
                              onClick={() => updateTechnition()}
                              className="btn btn-primary me-2"
                            >
                              Update
                            </button>
                            <button
                              onClick={() => technitionEvent("view")}
                              className="btn btn-secondary"
                            >
                              Cancel
                            </button>
                          </>
                        ) : eventname === "delete" ? (
                          <>
                            <button
                              onClick={() => deleteTechnition(formik.values.techn_id)}
                              className="btn btn-danger me-2 "
                            >
                              Delete
                            </button>
                            <button
                              onClick={() => technitionEvent("view")}
                              className="btn btn-secondary"
                            >
                              Cancel
                            </button>
                          </>
                        ) : (
                          <>
                            {/* <button onClick={() => navigate('/technitionloyee')} className='btn btn-primary' >Back</button> */}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/*  loader and error handler */}
          {/*  {iserror === false || iserror === true ? <Alertmsg alertmsg={ismessage} type={iserror} /> : <></>} */}
          <Toastmessage ref={ref} />
          {/* <Alertmsg ref={ref}/> */}
        </div>
      </div>
    );
  }
};

export default Technitionevent;
